import React, { useEffect } from "react";
import { useAtom } from "jotai";
import { timeSettingsAtom } from "../App";

const earthTimeSettings: TimeSettings = {hoursPerDay: 24, daysPerYear: 365};

function TimeSettingsControls() {
    // Enforce Earth time settings and hide the selector UI
    const [, setTimeSettings] = useAtom(timeSettingsAtom);
    useEffect(() => {
        setTimeSettings(earthTimeSettings);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return null;
}

export default React.memo(TimeSettingsControls);